<template>
  <v-navigation-drawer
    v-model="profileDrawer"
    temporary
    absolute
    class="secondary profile-drawer"
    :width="profileDrawerWidth"
    :style="`padding-left: ${drawerPadding}px`"
  >
    <v-layout column>
      <v-toolbar dense color="transparent" dark flat>
        <v-list p-0>
          <v-list-tile>
            <v-list-tile-content></v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                fab
                flat
                small
                @click.stop="
									profileDrawer = false;
									toggleEditMode('close');
									SET_VALUE({
										name: 'primaryDrawer',
										value: true
									});
									changePassword = false;
								"
              >
                <div class="v-icon">
                  <fa-icon :icon="['fal', 'times']" size="lg" />
                </div>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <transition name="cards">
        <v-form
          class="profile-form"
          v-if="form != null && !changePassword"
          @keyup.enter.prevent="saveForm"
        >
          <v-container pt-0>
            <v-avatar size="75px">
              <img :src="user.photo_url" :alt="user.name" />
            </v-avatar>

            <!-- TODO Move to Sweet Alert -->
            <v-dialog
              v-model="imageModal"
              persistent
              no-click-animation
              width="332"
              v-show="editing"
            >
              <v-tooltip color="primary" right slot="activator">
                <v-btn fab flat slot="activator" dark @click="resetImage">
                  <div class="v-icon">
                    <fa-icon :icon="['far', 'camera']" />
                  </div>
                </v-btn>
                <span>Edit</span>
              </v-tooltip>

              <v-card>
                <v-card-text>
                  <div class="image-uploader">
                    <div class="image-uploader__inner">
                      <image-cropper
                        v-model="myCroppa"
                        :placeholder="
													'Drag file here or click to choose'
												"
                        :placeholder-font-size="20"
                        :placeholder-color="'#000000'"
                        :input-attrs="{ name: 'photo' }"
                        :zoom-speed="10"
                        :width="300"
                        :height="300"
                        replace-drop
                        accept=".jpg, .png, .gif"
                        prevent-white-space
                        :initial-image="user.photo_url"
                      ></image-cropper>
                    </div>
                  </div>
                </v-card-text>

                <v-card-actions class="px-3 pb-3">
                  <v-btn color="error" @click="imageModal = false">Cancel</v-btn>
                  <v-btn flat @click="resetImage">Reset</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click="saveImage">Submit</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-card class="pt-3" dark flat color="transparent">
              <div v-for="formField in formFields" :key="formField.key" class="mb-4">
                <v-text-field
                  height="27px"
                  color="tertiary"
                  :label="formField.label"
                  :type="formField.type"
                  :name="formField.key"
                  :mask="formField.mask"
                  v-if="
										formField.type == 'text' ||
											formField.type == 'email' ||
											formField.type == 'tel'
									"
                  v-show="
										(form[formField.key] || editing) &&
											formField.visible
									"
                  v-model="form[formField.key]"
                  flat
                  :disabled="!editing || !formField.editable"
                  @keyup.enter.prevent="saveForm"
                  :hide-details="
										!form.errors.has(formField.key)
									"
                  :error="form.errors.has(formField.key)"
                  :error-count="
										form.errors.has(formField.key)
											? form.errors.get(formField.key)
													.length
											: 0
									"
                  :error-messages="
										form.errors.get(formField.key)
									"
                  @change="form.errors.forget(formField.key)"
                ></v-text-field>

                <v-autocomplete
                  height="27px"
                  color="tertiary"
                  dense
                  :label="formField.label"
                  :type="formField.type"
                  :name="formField.key"
                  v-if="formField.type == 'select'"
                  :items="formField.items"
                  :item-text="formField.text"
                  :item-value="formField.value"
                  v-show="form[formField.key] || editing"
                  v-model="form[formField.key]"
                  :disabled="!editing || !formField.editable"
                  @keyup.enter.prevent="save"
                  :hide-details="
										!form.errors.has(formField.key)
									"
                  :error="form.errors.has(formField.key)"
                  :error-count="
										form.errors.has(formField.key)
											? form.errors.get(formField.key)
													.length
											: 0
									"
                  :error-messages="
										form.errors.get(formField.key)
									"
                  @change="form.errors.forget(formField.key)"
                  browser-autocomplete="disabled"
                ></v-autocomplete>

                <div class="dealer-logo" v-if="formField.type == 'image'">
                  <label
                    class="dealer-logo__label"
                    :class="
											editing
												? 'white--text'
												: 'tertiary--text'
										"
                    v-if="editing || form[formField.key]"
                  >{{ formField.label }}</label>
                  <image-select
                    v-model="form[formField.key]"
                    :reset.sync="resetImages"
                    :src="user[formField.key]"
                    :name="formField.key"
                    :type="formField.type"
                    v-if="editing"
                  ></image-select>
                  <img
                    class="dealer-logo__img"
                    :src="user[formField.key]"
                    v-if="!editing && user[formField.key]"
                    :alt="form.company"
                  />
                </div>
              </div>

              <div class="mb-4">
                <button type="button" @click="changePassword = true">
                  Change Password
                  <!-- <fa-icon :icon="['far', 'lock']" fixed-width size="sm"/> -->
                </button>
              </div>

              <v-layout justify-space-between>
                <v-btn
                  class="ml-0"
                  flat
                  outline
                  @click="toggleEditMode('open')"
                  v-if="!editing"
                >Edit</v-btn>
                <v-btn class="ml-0" flat outline @click="resetForm" v-if="editing">Cancel</v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  class="mr-0"
                  flat
                  outline
                  @click.stop="saveForm"
                  v-if="editing"
                >Save</v-btn>
              </v-layout>
            </v-card>
          </v-container>
        </v-form>
      </transition>

      <transition name="cards">
        <change-password-form v-if="changePassword" @hide-change-password="changePassword = false"></change-password-form>
      </transition>
    </v-layout>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import ChangePasswordForm from "@components/partials/ChangePasswordForm";
import ImageSelect from "@components/partials/ImageSelect";
import { log } from "util";
// import Errors from "@root/helpers/Errors";

export default {
  data() {
    return {
      myCroppa: {},
      imgUrl: "",
      resetImages: false,
      showPassword: false,
      imageModal: false,
      editing: false,
      loading: false,
      form: null,
      changePassword: false
    };
  },

  components: { ChangePasswordForm, ImageSelect },

  computed: {
    ...mapGetters({
      _profileDrawer: "profileDrawer"
    }),

    ...mapGetters([
      "user",
      "mini",
      "primaryDrawer",
      "drawerSizes",
      "privacy",
      "statesList",
      "statesNames"
    ]),

    formFields() {
      return [
        {
          key: "name",
          label: "Name",
          type: "text",
          editable: true,
          visible: true
        },
        {
          key: "role.name",
          label: "Role",
          type: "text",
          editable: false,
          visible: true
        },
        {
          key: "company",
          label: "Company",
          type: "text",
          editable: true,
          visible: true
        },
        {
          key: "logo_url",
          label: "Company Logo",
          type: "image",
          editable: true,
          visible: true
        },
        {
          key: "address",
          label: "Address",
          type: "text",
          editable: true,
          visible: true
        },
        {
          key: "address2",
          label: "Address Line 2",
          type: "text",
          editable: true,
          visible: true
        },
        {
          key: "city",
          label: "City",
          type: "text",
          editable: true,
          visible: true
        },
        {
          key: "state",
          label: "State",
          type: "select",
          editable: true,
          visible: true,
          items: this.statesList(
            this.getObjectValue("form.country_code", this, "US")
          ),
          text: "name",
          value: "abbreviation"
        },
        {
          key: "country_code",
          label: "Country",
          type: "select",
          editable: true,
          visible: true,
          items: this.countryList,
          text: "name",
          value: "abbreviation"
        },
        {
          key: "zip",
          label: "Zip",
          type: "text",
          editable: true,
          visible: true
        },
        {
          key: "phone",
          label: "Phone",
          type: "tel",
          editable: true,
          visible: true,
          mask: this.getPhoneMask
        },
        {
          key: "cell_phone",
          label: "Cell Phone",
          type: "tel",
          editable: true,
          visible: true,
          mask: this.getPhoneMask
        },
        {
          key: "email",
          label: "Email",
          type: "email",
          editable: true,
          visible: true
        },
        {
          key: "modifier",
          label: "Modifier",
          type: "text",
          editable: false,
          visible: !this.privacy
        },
        {
          key: "rope_hoist_modifier",
          label: "Stock Wire Rope Hoist - Modifier",
          type: "text",
          editable: false,
          visible: !this.privacy
        }
      ];
    },

    getPhoneMask() {
      return ["US", "CA"].indexOf(
        this.getObjectValue("form.country_code", this, "US")
      ) > -1
        ? "phone"
        : null;
    },

    profileDrawer: {
      get() {
        return this._profileDrawer;
      },
      set(value) {
        this.SET_VALUE({
          name: "profileDrawer",
          value
        });

        this.resetForm();
      }
    },

    drawerPadding() {
      if (this.primaryDrawer) {
        return !this.mini
          ? this.drawerSizes.primary.full
          : this.drawerSizes.primary.mini;
      } else {
        return 0;
      }
    },

    profileDrawerWidth() {
      if (this.primaryDrawer && this.mini) {
        return this.drawerSizes.primary.mini + this.drawerSizes.profile.full;
      } else if (this.primaryDrawer && !this.mini) {
        return this.drawerSizes.primary.full + this.drawerSizes.profile.full;
      } else {
        this.drawerSizes.profile.full;
      }
    },

    countryList() {
      return window.Spark.countries;
    }
  },

  methods: {
    ...mapMutations(["SET_VALUE", "UPDATE_USER"]),

    ...mapMutations("admin", ["updateUserFields"]),

    toggleEditMode(value) {
      if (value == "open") {
        this.editing = true;
      } else if (value == "close") {
        this.editing = false;
      } else {
        this.editing = !this.editing;
      }

      this.$nextTick(() => {
        this.$vuetify.goTo(0, {
          duration: 500,
          container: ".profile-drawer"
        });
      });
    },

    resetForm() {
      this.formFields.forEach(item => {
        if (this.user.hasOwnProperty(item.key)) {
          this.form[item.key] = this.user[item.key];
        }
        this.form.errors.forget(item.key);
      });

      this.toggleEditMode("close");
    },

    saveForm() {
      this.loading = true;
      Spark.patch("/api/user/profile", this.form)
        .then(({ user }) => {
          this.uploadDealerLogo()
            .then(() => {
              this.UPDATE_USER(user);
              this.updateUserFields({ data: user });
            })
            .finally(() => {
              this.loading = false;
              this.toggleEditMode("close");
            });
        })
        .catch(error => {
          this.loading = false;
        });
    },

    resetImage() {
      this.myCroppa.refresh();
    },

    saveImage() {
      let fileType = this.myCroppa.$refs.fileInput.files[0].type;

      this.myCroppa.generateBlob(
        blob => {
          if (blob === null) {
            this.deleteImage();
          } else {
            this.uploadImage(blob);
          }
        },
        fileType,
        0.8
      ); // 80% compressed jpeg file
    },

    uploadImage(blob) {
      let formData = new FormData();
      formData.append("photo", blob);

      axios
        .post("/api/user/profile/photo", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(({ data }) => {
          this.UPDATE_USER(data);
          this.imageModal = false;
          this.myCroppa.refresh();
        })
        .catch(response => {
          alert(response);
        });
    },

    deleteImage() {
      axios
        .delete("/api/user/profile/photo")
        .then(({ data }) => {
          this.UPDATE_USER(data);
          this.myCroppa.refresh();
          this.imageModal = false;
        })
        .catch(response => {
          alerts(response);
        });
    },

    uploadDealerLogo() {
      if (this.form.logo_url.type) {
        let formData = new FormData();

        formData.append("photo", this.form.logo_url);

        return axios
          .post("/api/user/logo/photo", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(({ data }) => {
            // console.log("data", data);
            this.SET_VALUE({
              name: "user.logo_url",
              value: data.logo_url
            });
          })
          .catch(response => {
            // alert(response);
          });
      } else {
        return new Promise((resolve, reject) => {
          resolve();
        });
      }
    }
  },

  created() {
    let formData = {};

    this.formFields.forEach(item => {
      formData[item.key] = this.getObjectValue(item.key, this.user);
    });

    this.form = new SparkForm(formData);
  },

  watch: {
    "form.country_code": function(value) {
      this.$set(this.form, "state", null);
    }
  }
};
</script>

<style lang="scss" scoped>
.dealer-logo {
  &__label {
    display: block;
    font-size: 16px;
    text-transform: uppercase;
    transform: scale(0.75);
    transform-origin: left;
    &.tertiary--text {
      font-weight: 700;
    }
  }
  &__img {
    max-width: 100%;
    height: auto;
  }
}
</style>
